type LenisLike = { stop?: () => void; start?: () => void };

export class DrawerController {
    private static toggle: HTMLElement | null = null;
    private static drawer: HTMLElement | null = null;

    static init(): void {
        this.toggle = document.querySelector<HTMLElement>(".no-header .toggle");
        this.drawer = document.querySelector<HTMLElement>("#main-drawer");
        if (!this.toggle || !this.drawer) return;

        const closeBtn = this.drawer.querySelector<HTMLElement>(".close");

        this.toggle.addEventListener("click", () => {
            this.set(this.drawer?.dataset.state !== "open");
        });

        closeBtn?.addEventListener("click", () => this.set(false));

        this.drawer.querySelectorAll<HTMLAnchorElement>("a").forEach((link) => {
            link.addEventListener("click", () => this.set(false));
        });

        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") this.set(false);
        });

        window.addEventListener("resize", () => {
            if (this.drawer?.dataset.state === "open") this.set(false);
        });
    }

    private static set(open: boolean): void {
        if (!this.drawer || !this.toggle) return;

        const icon = this.toggle.querySelector<HTMLElement>("i");

        this.drawer.dataset.state = open ? "open" : "closed";
        this.drawer.setAttribute("aria-hidden", open ? "false" : "true");
        this.toggle.setAttribute("aria-expanded", open ? "true" : "false");
        this.toggle.classList.toggle("is-open", open);
        document.documentElement.classList.toggle("is-drawer-open", open);

        if (icon) {
            icon.classList.toggle("fa-bars", !open);
            icon.classList.toggle("fa-xmark", open);
        }

        const lenis = (window as unknown as { lenis?: LenisLike }).lenis;
        if (open) {
            lenis?.stop?.();
        } else {
            lenis?.start?.();
        }
    }
}
